export default {
    default: 'en-US',
    Chinese: 'zh-CN',
    English: 'en-US'
}